<template>
  <transition name="fade" mode="out-in">
    <div v-if="_is_modal_opened" :class="['modal-keeper', (MODAL_DATA.data?.disablePosition) ? 'disable-position' : '', addeClasses]" :style="inlineStyles">
      <div class="modal-keeper__background"  @click="backgroundClick()" />
      <div class="modal-keeper__modal-window">
        <suspense>
          <component
            :is="importComponent(MODAL_DATA.data?.component)"
            :data="MODAL_DATA.data?.data"
            @close_modal="closeModal()"
          />
          <template #fallback>
            <div class="modal-keeper__loader-wrapper">
              <icon-close-bordered class="modal-keeper__close-cross-button" @click="closeModal()" />
              <div class="modal-keeper__loading-state" />
            </div>
          </template>
        </suspense>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, inject, defineAsyncComponent } from "vue";
import IconCloseBordered from "@/components/ui/icons/IconCloseBordered.vue";
import { useBodyLockSwitcher } from "@/js/composables/bodyLock";
const $emitter = inject("emitter");

const MODAL_DATA = {
  data: null
}
const withoutLock = ref(false)
const _is_modal_opened = ref(false)
const isPreventedOutsideClick = ref(false)
const inlineStyles = ref()
const addeClasses = ref()

$emitter.on("openModal", (value) => {
  addeClasses.value = null;
  inlineStyles.value = null;
  MODAL_DATA.data = value
  inlineStyles.value = value?.data?.style
  addeClasses.value = value?.data?.class
  withoutLock.value = !!value?.withoutLock
  _is_modal_opened.value = !_is_modal_opened.value
  manageBodyClass()
  if(value?.isPreventedOutsideClick){
    isPreventedOutsideClick.value = true
  }
});

function closeModal () {
  _is_modal_opened.value = false
  manageBodyClass()
  withoutLock.value = false
}

function backgroundClick() {
  if(isPreventedOutsideClick.value){
    return
  }else {
    _is_modal_opened.value = false
    manageBodyClass()
    withoutLock.value = false
  }
}
function manageBodyClass () {
  if(withoutLock.value){
    useBodyLockSwitcher(false) 
    return  

  }else {
    // useBodyLockSwitcher(_is_modal_opened)
  if (_is_modal_opened.value) {
    document.body.classList.add("modal-open");
  } else {
    setTimeout(() => {
      document.body.classList.remove("modal-open");
    }, 100)
  }
  }

}

function importComponent (componentName) {
  return defineAsyncComponent(() => import(`../../components/modals/windows/ModalWindow${componentName}.vue`).then(
    (mod) => {
      return mod
    },
    (error) => {
      console.log(error);
      return null
    }
  ))
}

// useBodyLockSwitcher(_is_modal_opened)
</script>

<style lang="scss" scoped>
.modal-keeper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--app-height);

  @include screenL {
      align-items: normal;
      justify-content: stretch;
      width: 100%;
      height: 100dvh;
    }

  &.disable-position {
    display: block;

    .modal-keeper__modal-window {
      position: absolute;
      left: 100%;
    }
  }

  &__background {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: #00000040;

    @include screenL {
      background-color: #fff;;
    }
  }

  &__modal-window {
    position: relative;
    z-index: 11;
    box-shadow: 0 25px 75px -15px rgba(8, 17, 49, 0.6);
    border-radius: 8px;


    @include screenL {
      width: 100%;
      height: 100dvh;
      border-radius: 0;
      left: 0 !important;
    }
  }

  &__loader-wrapper {
    position: relative;
    width: 512px;
    height: 471px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FFF;
    border-radius: 8px;

    @include screenL {
      width: 512px!important;
    }

    @include screenM {
      width: calc(100vw - 16px)!important;
      max-height: calc(var(--app-height) - 8px)!important;
    }
  }

  &__loading-state {
    width: 40px;
    height: 40px;
    border: 4px solid var(--primary-color);
    border-radius: 50%;
    border-right-color: transparent;
    animation: .7s linear infinite spinner-border;
  }

  &__close-cross-button {
    position: absolute;
    z-index: 2;
    top: 16px;
    right: 16px;
    width: 24px;
    height: 24px;
    cursor: pointer;

    color: var(--font-color-secondary);
    transition: color .2s;

    &:hover {
      color: var(--hover-color);
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;

  .modal-keeper__modal-window {
    transition: transform 0.4s ease;
  }
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;

  .modal-keeper__modal-window {
    transform: scale(0.9);
  }
}

@keyframes spinner-border {
  to { transform: rotate(360deg) #{"/* rtl:ignore */"}; }
}

.check-positions-modal {
  align-items: end;

  // bottom: 0;

  :deep(.modal-keeper__modal-window){
    box-shadow: none;
  }
  :deep(.modal-create){
    width: auto;
    border-radius: 24px 24px 0 0;
  }
  :deep(.modal-create__header){
    display: none;
  }
  :deep(.modal-create__body){
    width: auto;
    max-height: none;
    padding: 0;
    max-height: none;
  }
  :deep(.modal-create__footer){
    display: none;
  }
  :deep(.modal-create__close-cross-button){
    top: -30%;
    right: -15%;

    @include screenL {
      display: block;
      top: -40%;
      right: 58px;
    }

    @include screenM {
      top: -30%;
    }
  }

  @include screenL {
    // height: 44dvh;
    // height: 66dvh;
    // height: auto;
    // height: var(--app-height);
    // align-items: center;
    // background-color: transparent;
    // top: unset;
    // display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   position: fixed;
    //   z-index: 10;
    //   top: 0;
    //   left: 0;
    //   width: 100%;
    //   height: var(--app-height);
    //   align-items: end;
    :deep(.modal-keeper__background){
      // position: fixed;
      // z-index: 10;
      // top: 0;
      // left: 0;
      // width: 100%;
      // height: 100vh;
      background-color: #00000040;
    }
    :deep(.modal-keeper){
      // display: flex;
      // align-items: center;
      // justify-content: center;
      // position: fixed;
      // z-index: 10;
      // top: 0;
      // left: 0;
      // width: 100%;
      // height: var(--app-height);
    }
    :deep(.modal-keeper__modal-window){
      // position: relative;
      // z-index: 11;
      // box-shadow: 0 25px 75px -15px rgba(8, 17, 49, 0.6);
      // border-radius: 8px;
      // height: 66%;
      height: 86.6vh;
      align-content: end;
      // overflow-y: auto;
    }
  }
  @include screenM {
    :deep(.modal-keeper__modal-window){
      height: 66vh;
    }
  }
}
</style>
